
import { mdiCheck } from "@mdi/js";

export default {
  async beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },

  layout: "auth",

  middleware: "auth",

  auth: "guest",

  data() {
    return {
      mdiCheck,
      prevRoute: null,
      dataBackgroundWebp: "bg.webp",
      dataBackgroundJpeg: "bg.jpg",
      successSent: false,
      valid: false,
      showPass: false,
      passRules: [
        (v) => !!v || this.$t("validations.pass-is-required"),
        (v) =>
          (v && v.length >= 8) ||
          this.$t("validations.use-a-minimum-characters", [8]),
      ],
      emailRules: [
        (v) => !!v || this.$t("validations.email-is-required"),
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*(?:\+\d+)?@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          this.$t("validations.e-mail-must-be-valid"),
      ],
      form: {
        username: "",
        password: "",
      },
      remember: false,

      error: null,

      errorQuery: {
        status: false,
        msg: "",
      },
      loading: false,
    };
  },

  computed: {
    redirectUrl() {
      if (this.$auth.user && [1, 2].includes(this.$auth.user.user_role)) {
        return "/dashboard";
      }
      return "/";
    },
  },

  methods: {
    validate() {
      console.log("validation data was successful");
      this.$refs.form.validate();
    },

    async submitForm() {
      this.loading = true;
      try {
        await this.$auth.loginWith("laravelPassport", {
          data: Object.assign({}, this.form, {
            client_secret: this.$config.apiSecret,
          }),
          url: "/oauth/token",
        });

        this.error = null;
        this.$router.push(this.redirectUrl);
      } catch (error) {
        this.errorQuery.msg = this.$t("incorrect-email-or-password");
        console.log("This is error ----------", error);
        this.loading = false;
      }
    },

    resetError() {
      this.errorQuery.status = false;
      this.errorQuery.msg = "";
    },
  },
};
